import React, { Component } from 'react';

export default class SingleValueDataWidget extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="panel panel-primary">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-xs-2 col-sm-1 col-md-2">
                            <i className={`fa ${this.props.icon} fa-3x`}></i>
                        </div>
                        <div className="col-xs-7 col-sm-8 col-md-6">
                            <h4>{this.props.label}</h4>
                        </div>
                        <div className="col-xs-3 col-sm-3 col-md-4 text-right widget-text">
                            <a
                                href="#"
                                onClick={() => {
                                    this.props.handleClick(this.props.filter);
                                }}
                            >
                                <h3>{this.props.value}</h3>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dashboard/single-value-widget.js